import React from 'react'
import { Wrapper } from '../../components'

import CircularProgress from '@material-ui/core/CircularProgress'

const LoadingPage = () => (
  <Wrapper>
    <div style={{ display: 'flex', height: '90vh', justifyContent: 'center', alignItems: 'center' }}>
    	<CircularProgress size={60} color='secondary' />
    </div>
  </Wrapper>
);

export default LoadingPage


// WEBPACK FOOTER //
// ./src/components/Authentication/LoadingPage.js